var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 14.3337C21.6665 13.2291 22.5619 12.3337 23.6665 12.3337H24.3332C25.4377 12.3337 26.3332 13.2291 26.3332 14.3337V15.0003C26.3332 16.1049 25.4377 17.0003 24.3332 17.0003H23.6665C22.5619 17.0003 21.6665 16.1049 21.6665 15.0003V14.3337ZM23.9998 35.667C25.2832 35.667 26.3332 34.617 26.3332 33.3337V24.0003C26.3332 22.717 25.2832 21.667 23.9998 21.667C22.7165 21.667 21.6665 22.717 21.6665 24.0003V33.3337C21.6665 34.617 22.7165 35.667 23.9998 35.667ZM23.9998 0.666992C11.1198 0.666992 0.666504 11.1203 0.666504 24.0003C0.666504 36.8803 11.1198 47.3337 23.9998 47.3337C36.8798 47.3337 47.3332 36.8803 47.3332 24.0003C47.3332 11.1203 36.8798 0.666992 23.9998 0.666992ZM23.9998 42.667C13.7098 42.667 5.33317 34.2903 5.33317 24.0003C5.33317 13.7103 13.7098 5.33366 23.9998 5.33366C34.2898 5.33366 42.6665 13.7103 42.6665 24.0003C42.6665 34.2903 34.2898 42.667 23.9998 42.667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e2655b51f5d19715e3003374a5ff3c8b.svg";
export { ForwardRef as ReactComponent };